<template>
  <dialog-zoomer v-on:close="lbHide" v-model="viz">
    <div class="close-box small grey" v-on:click="lbHide"></div>
    <div class="login-dialog sg-dialog">
      <div v-show="!loggedIn">
        <div class="flex-broom">
          <div class="flexb-lpan">
            <div class="title"><logo-button :width="185" /></div>
            <div class="title brown">{{ $nippets.welcomeBack }}</div>
            <div class="title">{{ $nippets.pleaseSignIn }}</div>
            <div class="message ">
              <div class="signin">
                <div>
                  <input type="text" :placeholder="$nippets.signin.username" name="username" v-model="username" />
                </div>
                <div>
                  <input type="password" :placeholder="$nippets.signin.password" name="password" v-model="password" />
                </div>
              </div>
              <div class="right-button-panel">
                <ix-router-link to="/forgot-password">{{ $nippets.forgotPass}}</ix-router-link>
              </div>
              <div class="button-panel">
                <small-button large v-on:click="handleSignIn" :loading="loading">{{ $nippets.login }}</small-button>
              </div>
              <div class="button-panel">
                <input type="checkbox" name="remember"/> {{ $nippets.rememberMe }}
              </div>
              
            </div>
          </div>
          <div class="login-right-panel">
            <div>
              {{ $nippets.noAccount }}
            </div>
            <div class="but-marg">
              <ix-router-link to="/my-area/signup" class="bigbutton">{{ $nippets.signup }}</ix-router-link>
            </div>
            <div>
              {{ $nippets.enjoyFeatures }}
            </div>
          </div>
        </div>
      </div>
      <div v-show="loggedIn">
        <div class="title">{{ $nippets.loggedIn }}</div>
        <div class="button-panel">
          <small-button large v-on:click="lbHide">{{ $nippets.close }}</small-button>
        </div>
      </div>
    </div>
  </dialog-zoomer>
</template>

<script>
import DialogZoomer from './DialogZoomer.vue'
import authHandler from '@/auth-handler.js'
import LogoButton from '@/components/buttons/LogoButton.vue'
import '@/css/my-area.css'

export default {
  components: {
    DialogZoomer,
    LogoButton
  },
  data () {
    return {
      viz: false,
      loading: false,
      username: '',
      password: ''
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.signedIn
    }
  },
  methods: {
    lbHide: async function () {
      this.viz = false
      this.$store.commit('hideLogin')
    },
    async handleSignIn () {
      this.loading = true
      let res = await authHandler.handleSignIn(this.username, this.password)
      this.loading = false
      console.log('sign in res', res)
      if(res === 'fail') {
        this.$k.messageBox('Login failed', 'Username or password not recognized.')
      }
      else if(res === 'change-pass'){
        this.$ixr.push('/change-password')
      }
      else if(res === 'reset-pass') {
        this.$ixr.push('/password-reset')
      }
      else if(res === 'confirm-email') {
        this.$ixr.push('/confirm-signup')
      }
      this.$store.commit('hideLogin')
    }
  },
  watch: {
    '$store.state.loginDialog.show': function () {
      console.log('got in watch')
      if(this.$store.state.loginDialog.show){
        this.viz = true
      }
    },
    '$route.path': function () {
      this.lbHide()
    }
  }
}
</script>

<style scoped>
.login-dialog{
  width:90vw;
  max-width: 600px;
  background-color:#e8e8e3;
  z-index:5001;
  padding:25px;
  cursor:default;
  max-height:90vh;
  overflow-y:auto;
  box-sizing: border-box;
  border-radius:6px;
}









.button-panel{
  margin:16px 0 10px 0;
}

.right-button-panel{
  text-align:right;
  font-size:13px;
  color:#6d6d64;
  margin-bottom:-20px;
}

.right-button-panel a{
  color:#6d6d64;
}

.right-button-panel a:hover{
  color:#ce0e2d;
}
</style>